import { BaseApiDataResponse } from './../Models/ApiData';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiUrls } from '../Models/ApiUrls';
import {
    CheckTemplateListResponse,
    SetCheckTemplate,
    CheckTemplateResponse,
} from '../Models/Control/ControleTemplates';
import { BaseDataService } from './Base/BaseDataService';
import { Constants } from '../Constants';

export interface IControleTemplateDataService {
    getCheckTemplateList: (
        params: {
            isActive?: boolean;
            count?: number; // ! Count n'est pas un paramètre obligatoire
        },
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateListResponse>;
    createCheckTemplate: (
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateResponse>;

    getCheckTemplate: (id: string, cts?: XHRRequestCanceler) => Promise<CheckTemplateResponse>;

    updateCheckTemplate: (
        id: string,
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateResponse>;

    deleteCheckTemplate: (id: string, cts?: XHRRequestCanceler) => Promise<BaseApiDataResponse>;
}

class ControleTemplateDataService extends BaseDataService implements IControleTemplateDataService {
    public getCheckTemplateList = (
        requestParams: {
            isActive?: boolean;
            count?: number; // ! Count n'est pas un paramètre obligatoire
        },
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateListResponse> => {
        const params = {
            is_active: requestParams.isActive || null,
            Count: requestParams.count
                ? requestParams.count
                : Constants.DEFAULT_ITEM_COUNT_PER_PAGE,
        };
        return this.get<CheckTemplateListResponse>(ApiUrls.CHECK_TEMPLATE_LIST, cts, { params });
    };

    public createCheckTemplate = async (
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        return await this.post<CheckTemplateResponse>(ApiUrls.CHECK_TEMPLATE_LIST, body, cts);
    };

    public getCheckTemplate = async (
        id: string,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        return await this.get<CheckTemplateResponse>(ApiUrls.CHECK_TEMPLATE_DETAILS(id), cts);
    };

    public updateCheckTemplate = async (
        id: string,
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        return await this.patch<CheckTemplateResponse>(
            ApiUrls.CHECK_TEMPLATE_DETAILS(id),
            body,
            cts
        );
    };

    public deleteCheckTemplate = async (
        id: string,
        cts?: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return await this.delete<BaseApiDataResponse>(ApiUrls.CHECK_TEMPLATE_DETAILS(id), cts);
    };
}

const ControleTemplateDataServiceName: string = 'ControleTemplateDataService';
export { ControleTemplateDataService, ControleTemplateDataServiceName };
